import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { VenueViewModel } from '../../models-views/venue.view.model';
import { AppCommon } from '../../providers/app-common';
@Component({
  selector: 'app-venue-room-media-link',
  standalone: false,
  templateUrl: './venue-room-media-link.component.html',
  styleUrl: './venue-room-media-link.component.scss',
})
export class VenueRoomMediaLinkComponent implements OnInit {
  linkForm!: FormGroup;
  loggedInUser: any;
  @Input() venueID!: any;
  @Input() venueRoomId!: any;
  @Input() mode: 'add' | 'edit' = 'add'; // 👈 edit or add
  @Input() mediaLink: any;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private VenueViewModel: VenueViewModel,
    @Inject(NZ_MODAL_DATA) public data: any
  ) {
    this.loggedInUser = AppCommon.getloggedInObject().user;
  }

  ngOnInit(): void {
    if (this.data) {
      this.venueID = this.data.venueID;
      this.venueRoomId = this.data.venueRoomId;
      this.mode = this.data.mode || 'add';
      this.mediaLink = this.data.mediaLink;
    }

    this.linkForm = this.fb.group({
      name: [null, [Validators.required]],
      url: [null, [Validators.required]],
      type: [null, [Validators.required]],
    });

    if (this.mediaLink) {
      this.linkForm.patchValue({
        name: this.mediaLink.name,
        url: this.mediaLink.url,
        type: this.mediaLink.type.toString(),
      });
    }
  }

  // Close modal without saving
  handleCancel(): void {
    this.modalRef.destroy();
  }

  // Save data and close modal
  addsLink(): void {
    if (this.linkForm.valid) {
      let linkData = { ...this.linkForm.value };
      if (!linkData.url.includes('http')) {
        linkData.url = 'https://' + linkData.url;
      }
      linkData.created_by = this.loggedInUser.id;
      linkData.venueID = this.venueID;
      linkData.venueRoomId = this.venueRoomId;

      this.VenueViewModel.createVenueRoomLink({
        ...linkData,
        Success: (response: any) => {
          this.modalRef.destroy(response);
        },
        Error: (err: any) => {},
      });

    }
  }

  addLink(): void {
    if (this.linkForm.valid) {
      let linkData = { ...this.linkForm.value };

      // ensure URL has protocol
      if (!linkData.url.includes('http')) {
        linkData.url = 'https://' + linkData.url;
      }

      // always include venue + room
      linkData.venueID = this.venueID;
      linkData.venueRoomId = this.venueRoomId;

      if (this.mode === 'add') {
        // add flow
        linkData.created_by = this.loggedInUser.id;

        this.VenueViewModel.createVenueRoomLink({
          ...linkData,
          Success: (response: any) => {
            this.modalRef.destroy(response); // return new record
          },
          Error: (err: any) => {},
        });
      } else if (this.mode === 'edit' && this.mediaLink) {
        linkData.id = this.mediaLink.id; // keep same id
        linkData.modified_by = this.loggedInUser.id;

        this.VenueViewModel.updateVenueRoomLink({
          ...linkData,
          Success: (response: any) => {
            this.modalRef.destroy(response);
          },
          Error: (err: any) => {},
        });
      }
    }
  }
}
